export var defaultPropArray = [];
export var defaultPropObject = {};